import React, { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "../../lib/config";
import Logo from "./Logo";

const nav = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Pricing", href: "#pricing" },
  { label: "Areas", href: "#areas" },
  { label: "Book", href: "#booking" },
  { label: "Tech Portal", href: "#test-report" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-16">
        <a href="#top" className="flex items-center" data-testid="logo-link">
          <Logo size={38} withText theme="light" />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(" ", "-")}`}
              className="font-display text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={BUSINESS.phoneHref}
            data-testid="header-call-btn"
            className="hidden sm:inline-flex btn-primary text-sm"
          >
            <Phone className="w-4 h-4" /> {BUSINESS.phone}
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 border border-slate-300"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="max-w-7xl mx-auto px-5 py-3 flex flex-col">
            {nav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-3 border-b border-slate-100 font-display font-medium"
              >
                {n.label}
              </a>
            ))}
            <a
              href={BUSINESS.phoneHref}
              className="btn-primary mt-3 justify-center"
              data-testid="mobile-call-btn"
            >
              <Phone className="w-4 h-4" /> Call {BUSINESS.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
